// GENERATED by scripts/fetch-cms.mjs — DO NOT EDIT.
// Source: Payload CMS (trainzilla-cms). Re-run `npm run cms:fetch`.

export const STRUCTURED_DATA: Record<string, unknown> = {
  "softwareApplication": {
    "name": "TrainZilla",
    "softwareVersion": "2.0",
    "datePublished": "2024-01-01",
    "applicationCategory": "BusinessApplication",
    "operatingSystem": [
      "Web",
      "iOS",
      "Android"
    ],
    "offers": [
      {
        "name": "Free Launch",
        "price": "0",
        "priceCurrency": "USD",
        "description": "Free for 30 days with your first client"
      },
      {
        "name": "Coach Pro",
        "price": "19",
        "priceCurrency": "USD",
        "description": "Unlimited clients, branded client app, own domain, AI-adjusted plans. Billed in US dollars outside India."
      },
      {
        "name": "Coach Pro (India)",
        "price": "499",
        "priceCurrency": "INR",
        "description": "Unlimited clients, branded client app, own domain, AI-adjusted plans. Billed in rupees in India."
      },
      {
        "name": "Gym Starter",
        "price": "1499",
        "priceCurrency": "INR",
        "description": "Up to 5 coach seats with face check-in, leads, renewals and desk payments"
      },
      {
        "name": "Gym Pro",
        "price": "3499",
        "priceCurrency": "INR",
        "description": "Up to 15 coach seats, multiple locations and per-location revenue"
      }
    ],
    "featureList": [
      "AI coaching agent that builds and weekly-adjusts client workout and diet plans",
      "Coach reviews and approves every AI plan before the client sees it",
      "In-dashboard AI assistant for managing your coaching business",
      "Workout builder with training-split templates and a video exercise library",
      "Diet and meal-plan builder with per-ingredient macro tracking",
      "Tutorial videos linked automatically to every exercise and recipe",
      "Client meal and exercise swaps with instant macro-impact preview",
      "Habit tracking with streaks, milestones and reusable master habits",
      "Custom client check-ins with photo, scale and text questions",
      "Session booking with availability and online or in-person options",
      "Progress tracking with Apple Health and Health Connect sync",
      "Clients pay coaches directly by UPI or the coach's own Stripe, PayPal or Wise link, with no commission",
      "Automated client invoices and desk payment records",
      "Marketplace to sell workout and diet plans and templates",
      "Multi-location gym and franchise dashboard with per-coach revenue",
      "Coach app plus a free client app for Android and iOS",
      "Plan PDF export"
    ]
  },
  "website": {
    "searchUrlTemplate": "https://trainzilla.app/search?q={search_term_string}"
  }
} as const
